import { useEffect } from "react";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { useTablesSocket } from "./useTablesSocket";
import {
  subscribeToTablesEvents,
  unsubscribeFromTablesEvents,
} from "./useTablesSocketEvents";

/**
 * Own the live table connection for a whole table session.
 *
 * Mount this ONCE, at the table scope layout. `useTablesSocket`'s cleanup
 * disconnects a module-level singleton, so a second mount elsewhere would let
 * one unmount kill the other's socket. Keeping it at the scope layout also
 * means moving between the bill and the ordering flow no longer tears the
 * connection down and re-establishes it.
 */
export const useTableSocket = (restaurantId: string, tableId: string) => {
  useEffect(() => {
    if (tableId) {
      useVenuesDataStore.getState().setVenuesData({ tableId });
    }
  }, [tableId]);

  useTablesSocket(restaurantId, tableId);

  useEffect(() => {
    subscribeToTablesEvents();
    return () => unsubscribeFromTablesEvents();
  }, []);
};
